import * as React from 'react';

import dynamic from 'next/dynamic';
import { ColorTheme as TradingViewColorTheme } from 'react-ts-tradingview-widgets';

const AdvancedRealTimeChartNoSSR = dynamic(
    () => import('react-ts-tradingview-widgets').then(w => w.AdvancedRealTimeChart),
    {
        loading: () => <span>Loading..</span>,
        ssr: false,
    },
);

type TradingViewChartProps = {
    className?: string;
    symbol: string;
    interval?: keyof typeof intervalMap;
    themeName: TradingViewColorTheme;
    autoSize?: boolean;
};

const intervalMap = {
    ytd: 'YTD',
    all: 'ALL',
    '1y': '12M',
    '6m': '6M',
    '3m': '3M',
    '1m': '1M',
    '1w': '5D',
    '24h': '1D',
} as const;

export const TradingViewChart = (props: TradingViewChartProps) => {
    const { className, interval = '24h', themeName, symbol, autoSize = true } = props;
    const mode = (themeName?.toLowerCase() || 'light') as TradingViewColorTheme;

    const toolbarBg = React.useMemo(() => {
        return getComputedStyle(document.body).getPropertyValue(`--color-${mode}-surface`);
    }, [mode]);

    return (
        <div className={className}>
            <AdvancedRealTimeChartNoSSR
                toolbar_bg={toolbarBg}
                key={themeName}
                theme={mode}
                symbol={symbol}
                range={intervalMap[interval]}
                interval="D"
                autosize={autoSize}
            ></AdvancedRealTimeChartNoSSR>
        </div>
    );
};

export type { TradingViewColorTheme };
